import React, { useState, useEffect } from "react";
import { ConfigurationPageStyle } from "./Configuration.style";
import TopBar from "../../components/TopBar/TopBar";
import { MainBodyStyle } from "../../styles/MainBodyStyles";
import Footer from "../../components/footer/Footer";
import { HeadingStyle } from "../../styles/HeadingStyles";
import TimePicker from "react-time-picker";
import { EmailValidationSchema } from "../../validations/EmailValidation";
import { TextErrorStyle } from "../../styles/ErrorStyles";
import { useDB } from "../../context/DynamoDBContext";
import { useQueryClient, useQuery } from "@tanstack/react-query";
import { useReload } from "../../context/ReloadContext";
import { getConfigurations } from "../../api/ConfigurationApi";
import { toast } from "react-toastify";
import moment from "moment";

const EmailConfigurations = () => {
  const { dynamoDBClient } = useDB();
  const queryClient = useQueryClient();
  const { reload } = useReload();

  const [time, setTime] = useState("");
  const [email, setEmail] = useState("");
  const [accounts, setAccounts] = useState(true);
  const [beacons, setBeacons] = useState(true);
  const [baseStation, setBaseStation] = useState(true);
  const [schedule, setSchedule] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const [error, setError] = useState("");
  const [enableApi, setEnableApi] = useState(false);
  const [data, setData] = useState([]);
  const [disableIcons, setDisableIcons] = useState(false);
  const [emailConfig, setEmailConfig] = useState({});

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (dynamoDBClient) {
      setEnableApi(true);
    } else {
      setEnableApi(false);
    }
  }, [dynamoDBClient]);

  useEffect(() => {
    if (reload) {
      queryClient.fetchQuery(["getEmailConfigurations"]);
    }
  }, [reload]);

  const handleError = (type) => {
    if (type === "getEmailConfigurations") {
      toast.error("Error while loading Configuration", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
  };

  const { data: configData, status: configStatus } = useQuery({
    queryKey: ["getEmailConfigurations"],
    queryFn: () => getConfigurations(dynamoDBClient, "Email"),
    enabled: enableApi,
    onSuccess: (data) => {
      if (data.length > 0) {
        const config = data[0];
        setEmailConfig(config);
        setData(config.ConfigurationData);
      } else {
      }
      setEnableApi(true);
    },
    onError: (error) => {
      console.log("getRssiConfigurations :", error);
      handleError("getRssiConfigurations");
    },
  });

  const Errors = (err) => {
    err.forEach((element) => {
      switch (element.split(":")[0]) {
        case "1":
          setError(element.split(":")[1]);
          break;
        default:
          setError("An Error has occured in validation");
          break;
      }
    });
  };

  const removeEmail = async (removeEmail) => {
    try {
      setDisableIcons(true);
      const val = data.filter((item) => item.Email != removeEmail);

      var params = {
        TableName: "Configurations",
        Key: {
          ConfigurationId: emailConfig.ConfigurationId,
          ModeType: "Email",
        },
        UpdateExpression: "SET ConfigurationData = :val ",
        ExpressionAttributeValues: {
          ":val": val,
        },
        ReturnValues: "ALL_NEW",
      };
      const result = await dynamoDBClient.update(params).promise();
      toast("Successfully Removed Email");
      setData(val);
      setDisableIcons(false);
    } catch (error) {
      toast.error("Error has Ocurred.Try Again", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
    setDisableIcons(false);
  };
  const addEmail = async (val) => {
    try {
      var params = {
        TableName: "Configurations",
        Key: {
          ConfigurationId: emailConfig.ConfigurationId,
          ModeType: "Email",
        },
        UpdateExpression: "SET ConfigurationData = :val ",
        ExpressionAttributeValues: {
          ":val": val,
        },
        ReturnValues: "ALL_NEW",
      };
      const result = await dynamoDBClient.update(params).promise();
      toast("Successfully Added Email");
      setData(val);
    } catch (error) {
      toast.error("Error has Ocurred.Try Again", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
    setBtnDisable(false);
    setEmail("");
  };

  const updateEmailConfigurations = async () => {
    setError("");
    setBtnDisable(true);
    const formData = {
      email: email,
    };

    await EmailValidationSchema.validate(formData, {
      abortEarly: false,
    })
      .then((value) => {
        if (!accounts && !beacons && !baseStation) {
          setBtnDisable(false);
          setError("Select Option from Trigger Email");
          return;
        }

        if (schedule) {
          if (time === "") {
            setBtnDisable(false);
            setError("Add Time for Schedule Email");
            return;
          }
        }
        const val = [
          ...data,
          {
            BaseStation: true,
            Time: "",
            Email: email,
            Beacons: true,
            Accounts: true,
          },
        ];
        addEmail(val);
      })
      .catch((err) => {
        setBtnDisable(false);
        Errors(err.errors);
      });
  };

  return (
    <ConfigurationPageStyle>
      <TopBar authorized={true} />
      <MainBodyStyle>
        <HeadingStyle>Email Configurations</HeadingStyle>
        <div className="configurationCardWidth configurationCard">
          <table className="table-div">
            <tbody>
              <tr className="row-div">
                <td>
                  <div className="field-div">Email:</div>
                </td>
                <td>
                  <input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    id="email"
                    maxLength={30}
                    placeholder="Enter Email"
                    className="form-control mt-1 input-field"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <button
            type="submit"
            className={"btn form-button"}
            disabled={btnDisable}
            onClick={updateEmailConfigurations}
          >
            Add Email
          </button>
          {error !== "" && <TextErrorStyle>{error}</TextErrorStyle>}
        </div>
        <div>
          <div className="table-container">
            <div className="table-div2">
              <table className="table table-hover">
                <thead className="table-head">
                  <tr>
                    <th scope="col" className="table-item">
                      #
                    </th>
                    <th scope="col" className="table-item">
                      Emails
                    </th>
                    <th scope="col" className="table-item">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {configStatus === "loading" || reload ? (
                    <tr>
                      <td colSpan={3}>
                        <p className="table-loading">Loading...</p>
                      </td>
                    </tr>
                  ) : data.length === 0 ? (
                    <tr>
                      <td colSpan={3}>
                        <p className="table-loading">No Email Added</p>
                      </td>
                    </tr>
                  ) : (
                    data.map((item, index) => (
                      <tr key={index}>
                        <th scope="row" className="table-item">
                          {index + 1}
                        </th>
                        <td className="table-item table-item2">{item.Email}</td>
                        <td className="table-item">
                          <i
                            title="Delete"
                            className={
                              disableIcons
                                ? "bi bi-trash delete-icon disable-icon"
                                : "bi bi-trash delete-icon"
                            }
                            onClick={() => {
                              removeEmail(item.Email);
                            }}
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </MainBodyStyle>
      <Footer style="footer" />
    </ConfigurationPageStyle>
  );
};

export default EmailConfigurations;
